let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fCDO8")).then(() => parcelRequire('4Lqeb'));